import { render, staticRenderFns } from "./committeeTable.vue?vue&type=template&id=dffae716"
import script from "./committeeTable.vue?vue&type=script&lang=js"
export * from "./committeeTable.vue?vue&type=script&lang=js"
import style0 from "./committeeTable.vue?vue&type=style&index=0&id=dffae716&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports